// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-Components-Container-Container-module__Container--f2nIW{max-width:var(--container-size);margin:0 auto;padding:0 20px;height:100%}`, "",{"version":3,"sources":["webpack://./src/Components/Container/Container.module.scss"],"names":[],"mappings":"AAAA,6DACE,+BAAA,CACA,aAAA,CACA,cAAA,CACA,WAAA","sourcesContent":[".Container {\n  max-width: var(--container-size);\n  margin: 0 auto;\n  padding: 0 20px;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `src-Components-Container-Container-module__Container--f2nIW`
};
export default ___CSS_LOADER_EXPORT___;
